module.exports = __webpack_public_path__ + "img/eletrodutoEspecificacoes2.6d0dc939.png";